import { Button } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import React from "react";
import styled from "styled-components";

import { DropdownSelectVariant } from "common/views/dropdownSelect/DropdownSelect.view";
import { OptionDropdownSelect } from "common/views/dropdownSelect/OptionDropdownSelect";
import { Fragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import CatalogLabels from "../Catalog.labels";
import { ICatalogMetaProps } from "./ICatalogMetaProps";
import { ButtonView } from "../../../common/views/button/Button.view";
import Icon from "../../../common/views/icon/Icon";

import InstitutionFilterComponent from "panels/institutions/InstitutionFilterComponent";

/**
 * Styled Component for search box
 */
const SearchBox = styled.input`
	width: 400px;
	border: 0;
	font-size: 15px;
	border-bottom: 1px solid #ccc;
	font-style: italic;
	padding-bottom: 5px;
	padding-right: 20px;
`;
const SearchIcon = styled(Button)`
	position: relative;
	right: 25px;
	cursor: pointer;
	z-index: 1;
`;

// copied from BundleEntries.panel.tsx
class SearchComponent extends React.Component<ICatalogMetaProps, {searchValue: string}> {
	public state = {searchValue: this.props.params["query"] || null};

	/* constructor(props) {
		super(props);
		this.state = {searchValue: null};
	} */

	/**
	* This function handles text change in search term box
	* set state for searchValue
	* @param event
	*/
	@autobind
	public onChangeSearchTerm(event) {
		const searchTerm = event.target.value;
		this.setState({ searchValue: searchTerm });
	}

	/**
	 * This function check if enter is pressed inside searchbox then
	 * it will fire searchCourses function to run search
	 * set state for searchValue
	 * @param event
	 * @param name
	 */
	@autobind
	public onKeyPress(event) {
		if (event.key === "Enter") {
			this.search();
		}
	}

	/**
	 * This function handles searching courses based on search term
	 * @param name
	 */
	@autobind
	public search() {
		this.props.setParams({...this.props.params, query: this.state.searchValue, pageNumber:0});
	}

	@autobind
	public clear() {
		this.setState({searchValue: ""}, this.search);
	}

	public render() {
		return (
			<React.Fragment>
				<SearchBox
					placeholder="Search for courses"
					value={this.state.searchValue}
					onChange={this.onChangeSearchTerm}
					onKeyPress={this.onKeyPress}
				/>
				{this.state.searchValue ? (
					<ButtonView onClick={this.clear} viewKey="clear">
						<Icon icon="cross" />
					</ButtonView>
				) : (
					<ButtonView onClick={this.search} viewKey="go">
						<Icon icon="search" />
					</ButtonView>
				)}
			</React.Fragment>
		);
	}
}

export const search: Fragment<ICatalogMetaProps> = {
	name: "Search",
	component: SearchComponent
};

const sortOptions = [
	{value: '-startDate', label: <Label k="sort.createdOn.desc" v="Newest" />},
	{value: 'startDate', label: <Label k="sort.createdOn.asc" v="Oldest" />},
	{value: 'title', label: <Label k="sort.name.asc" v="Name" />}
];

export const sort: Fragment<ICatalogMetaProps> = {
	name: "Sort",
	component: ({params, setParams}) => (
		<OptionDropdownSelect
			onChange={(value) => setParams({...params, sort: value, pageNumber:0})}
			options={sortOptions}
			value={params.sort}
			variant={DropdownSelectVariant.MINIMAL}
			viewKey="refine.sort"
		>
			<CatalogLabels.Labels.SortBy />
		</OptionDropdownSelect>
	)
};


export const institution: Fragment<ICatalogMetaProps> = {
	name: "Institution",
	component: ({params, setParams, replaceParams}) => {
		return (
			<InstitutionFilterComponent 
				defaultInst={params.institution}
				setInstitution={(institution,first)=>{
						if(!institution){
							return;
						}
						if(first)
							replaceParams({institution});
						else
							setParams({institution});
					}
				}
			/>	
		);
		
	}
};
// completion



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/filterFragments.tsx